import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { AppiceService } from 'src/app/services/appice.service';
import { CartService } from 'src/app/services/cart.service';
import { ContactService } from 'src/app/services/contact.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { ShippingService } from 'src/app/services/shipping.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { VerificationModalComponent } from '../verification-modal/verification-modal.component';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-contact-info-form',
  templateUrl: './contact-info-form.component.html',
  styleUrls: ['./contact-info-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContactInfoFormComponent implements OnInit {

  guestMobileNumberControl: FormControl = new FormControl('');
    mobileNumberPattern: RegExp = /^(413|414|050|054|055|056|052|058|04|06|02|09)\d{7}$|^784[0-9]{4}[0-9]{7}[0-9]{1}$/;
    mobileErrorMSG: any;
    primaryNumber: any;
    maskedAccountNo:any;
    otpIcon: string = undefined;
    valid: boolean;
    isArabic: boolean;
    token:any;
    secoundyNumbers = [];
    @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
    config = {
      allowNumbersOnly: true,
      length: 6,
      isPasswordInput: true,
      disableAutoFocus: true,
      placeholder: '●',
      inputStyles: {
        width: '36px',
        height: '36px',
        color: '#E00800',
      },
    };
    showOTPError = true;
    OTPErrorMSG: any;
    otp: string = '';
    otpErrorMessage: boolean = false;
    otpVerified: boolean = false;
    alternativeContactConsent: boolean = false; 
    showVerifyOption: boolean = true;
    verifiedAlternativeNumber: string = '';
    showConsentPopup:boolean = true;
    showAlternateContact:boolean = false;
    showConsentTooltip:boolean = false;
    mobileAndDeviceSku:boolean = false;
    isMobilePlanSku: boolean = false;
    isDeviceSku: boolean = false;
  isSubmitted = false;
  ContactForm: any;
  @Input() userInfo: any;
  @Input() userLoggedIn: any;
  @Input() disableDevicePurchaseAlternateContactNumber: boolean;
  @Input() checkeSimeavailable: boolean;
  @Input() stitchFields: any;
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  @Output() editContactInfo: EventEmitter<any> = new EventEmitter();
  selectedShippingAddress: any;
  personalInfo: any;
  cart: any;
  consentDone = false;
  constructor(
    private SS: SubjectService,
    private FB: FormBuilder,
    private SHS: ShippingService,
    private modalController: ModalController,
    private CS: ContactService,
    private SHIPS: ShippingService,
    private route: Router,
    private US: UserInfoService,
    private CRTS: CartService,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private CNS: ContactService,
    private UTS: UtilitiesService,
    private appice: AppiceService,
    private PS: ProductService,
    private translate: TranslateService,    
    public popoverController: PopoverController,
  ) {}

  ngOnInit() {
    if (this.checkeSimeavailable) {
      this.ContactForm = this.FB.group({
        firstname: ['', [Validators.pattern('^[a-zA-Zء-ي ]+$')]],
        lastname: ['', [Validators.pattern('^[a-zA-Zء-ي ]+$')]],
        email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
        mobileNumber: [
          '',
          [
            Validators.pattern('^[0][0-9]{9}$'),
            Validators.minLength(10),
          ],
        ],
        alternativeMobileNumber: [
          '',
          [
            Validators.pattern(this.mobileNumberPattern),
            Validators.minLength(9),
          ],
        ],
        alternativeNumberConsent: [false],
        enableAlternateContact: [false]
     
      });

    } else {
      this.ContactForm = this.FB.group({
        firstname: ['', [Validators.required, Validators.pattern('^[a-zA-Zء-ي ]+$')]],
        lastname: ['', [Validators.required, Validators.pattern('^[a-zA-Zء-ي ]+$')]],
        email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
        mobileNumber: [
          '',
          [
            Validators.required,
            Validators.pattern('^[0][0-9]{9}$'),
            Validators.minLength(10),
          ],
        ],
        alternativeMobileNumber: [
          '',
          [
            Validators.pattern(this.mobileNumberPattern),
            Validators.minLength(9),
          ],
        ],
        alternativeNumberConsent: [false],
        enableAlternateContact: [false]
        // homeCountryNumber: [
        //   ''
        // ],
        // ^[^0-9]+$
      });
    }

    this.getAllAccounts();
    if (this.userInfo) {
      this.ContactForm.controls['firstname'].setValue(this.userInfo.firstName);
      this.ContactForm.controls['lastname'].setValue(this.userInfo.lastName);
      this.ContactForm.controls['email'].setValue(this.userInfo.email);
      this.ContactForm.controls['mobileNumber'].setValue(
        this.userInfo.mobileNo
      );
      this.ContactForm.controls['alternativeMobileNumber'].setValue((this.userInfo?.alterntiveNumber == null || this.userInfo?.alterntiveNumber == undefined) ? null : this.userInfo?.alterntiveNumber);
      this.ContactForm.controls['alternativeNumberConsent'].setValue(this.userInfo?.alterntiveNumberConsent);
      this.ContactForm.controls['enableAlternateContact'].setValue(false);
      this.otpVerified = this.userInfo?.otpVerified;
      if(this.otpVerified) {this.otpIcon = "verified"; this.verifiedAlternativeNumber = this.userInfo?.alterntiveNumber , this.showConsentPopup = false;}
      // this.ContactForm.controls['homeCountryNumber'].setValue(this.userInfo.homeCountryNumber)
    }
    this.cart = this.CRTS.getCart();
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    this.getCart();
  }

  get errorControl() {
    return this.ContactForm.controls;
  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  addContact() {
    this.appice.passAllProductsToCart("Checkout","Contact_Info_Save", this.cart , this.userInfo)
    const payload = {
      firstName: this.ContactForm.controls['firstname'].value,
      lastName: this.ContactForm.controls['lastname'].value,
      mobileNo: this.ContactForm.controls['mobileNumber'].value,
      email: this.ContactForm.controls['email'].value,
      alternateContactNumer: this.otpVerified == true ? this.getControlerValue('alternativeMobileNumber') : null,
      alterntiveNumberConsent: this.otpVerified == true ? this.getControlerValue('alternativeNumberConsent') : false,
      otpVerified: this.otpVerified
    };

    this.CS.storePersonalInfo(payload).subscribe((r: any) => {
      this.GAS.add_personal_info(this.cart);
      this.GAS.checkoutOptimizationAddressContactInfo('add_contact_info', 'checkout', 'contact info','save','checkout',this.cart?.items, this.stitchFields); 
      this.AAS.addLinkCTAEvent(
        'Save',
        'other',
        'Shipping',
        'Contact Info',
        'Save contact info',
      );
      if (r && r.selectedAddress) {
        this.selectedShippingAddress = r.selectedAddress;
      }
      if (r && r.personalInfo) {
        this.personalInfo = r.personalInfo;
        if(this.otpVerified) {
          this.personalInfo.alterntiveNumberConsent = this.getControlerValue('alternativeNumberConsent');
          this.personalInfo.alternateContactNumer = this.getControlerValue('alternativeMobileNumber');
          this.personalInfo.otpVerified = this.otpVerified;
        }
        this.SS.refreshContactInfo.next(this.personalInfo);
      }

      if (this.userInfo) {
        const payload = { 
          "mobileNo": this.personalInfo.mobileNo,
           "email": this.personalInfo.email,
            "locale": this.userInfo.locale 
          };
        this.CNS.updateuserinfoForEshop(payload).subscribe((r) => {
          this.SS.refreshContactInfo.next(this.personalInfo);
          this.editContactInfo.emit();
          this.dismiss();
        }, (e) => {
          this.UTS.error(e.error.message)
          this.editContactInfo.emit();
        })
      } else {
        this.US.set(this.personalInfo);
        this.SHIPS.setSelectedShipping(this.selectedShippingAddress);
        // setTimeout(() => {
        //   this.route.navigateByUrl(
        //     '/checkout/delivery?lang=' + this.UTS.getLocaleLanguage()
        //   );
        // }, 500);
        this.editContactInfo.emit();
      }
    });
  }
  
  contactFormSubmitted() {
    if (this.ContactForm.valid) {
      this.formSubmit.emit(this.ContactForm);
    }
  }

  async openVerificationModal(data) {   
    const modal = await this.modalController.create({
      component: VerificationModalComponent,
      cssClass: 'verification-modal modal-fullscreen',
      componentProps: { data: data },
    });
    modal.onDidDismiss().then((x: any) => {
      if(x && x.data && x.data.verified){
        this.otpVerified = x.data.verified;
        if(this.otpVerified) { this.otpIcon="verified"; this.verifiedAlternativeNumber = this.getControlerValue("alternativeMobileNumber");
        this.SS.refreshAlternativeContactInfo.next(true);
        if(this.getControlerValue("alternativeNumberConsent") != true) {
          this.consentDone =  false;
        }
       
      }
      console.log(" I am called "+ this.otpVerified)
      }
    })
  
    return await modal.present();
  }

  onMobileKeyPress(element: HTMLElement) {
    this.mobileErrorMSG = undefined;
    this.otpIcon=undefined;
     let numVal = this.getControlerValue('alternativeMobileNumber');
     if(numVal.length < 10) {return}
     if(this.ContactForm.controls['alternativeMobileNumber'].Invalid) {  this.otpIcon="error"; return ; }
    //  else if(numVal == this.primaryNumber){ 
    //   this.otpIcon="error";
    //   this.translate.get('ALTERNATIVE_PRIMARY_ERROR').subscribe((message) => {
    //     this.showOTPError = true;
    //     this.mobileErrorMSG = message;
    //   });
    // }
    //  else if(this.secoundyNumbers.indexOf(numVal) > -1) {
    //   this.otpVerified = true ; 
    //   this.showVerifyOption = false
    // } 
    else if(numVal == this.verifiedAlternativeNumber) {this.otpIcon="verified";return;}
     else {
      this.validateAlternativeAccount(numVal);
     }
  }

  getAllAccounts() {
    this.US.getAllAccount().subscribe((r: any) => {
      if (r) {
        let accounts = r.userAccounts;
        if (accounts && accounts.length > 0) {
          this.extratPrimaryAndSecNums(accounts)
         
        }
      }
    }, (e) => {
      this.primaryNumber = null;
    });
  }


  getOtp() {
    this.otpIcon="spinner";
    let alternativeMobileNumber = this.ContactForm.controls['alternativeMobileNumber'].value;
    this.PS.generateOTP(alternativeMobileNumber).subscribe(
      (resp) => {
        this.otpIcon= undefined;
        this.maskedAccountNo = resp.maskedAccountNo;
        this.token = resp?.token;
       let data = {
        token: this.token,
        maskedAccountNo: this.maskedAccountNo,
        mobileNumber: alternativeMobileNumber,
        viewOtpScreen: true,
        checkoutFlow: true
       }
        // }
       this.openVerificationModal(data);
      },
      (e) => {
        // this.UTS.error(e.error.message);
        this.otpIcon="error";
        this.mobileErrorMSG = e.error.message;
      }
    );
    // this.PS.accountNoIndividualLoginEligibility(alternativeMobileNumber).subscribe(
    //   (data: any) => {
    //     if (data.eligible == "true") {
    //       //this.GAS.eligibilityCheck('Continue', this.mobileNumber, this.data.productType, this.data.displayName, '');
    //       this.PS.generateOTP(alternativeMobileNumber).subscribe(
    //         (resp) => {
    //           this.otpIcon= undefined;
    //           this.maskedAccountNo = resp.maskedAccountNo;
    //           this.token = resp?.token;
    //          let data = {
    //           token: this.token,
    //           maskedAccountNo: this.maskedAccountNo,
    //           mobileNumber: alternativeMobileNumber,
    //           viewOtpScreen: true,
    //           checkoutFlow: true
    //          }
    //           // }
    //          this.openVerificationModal(data);
    //         },
    //         (e) => {
    //           // this.UTS.error(e.error.message);
    //           this.otpIcon="error";
    //           this.mobileErrorMSG = e.error.message;
    //         }
    //       );
    //     } else {
    //       this.otpIcon="error";
    //       let errorTitle = 'Invalid number';
    //       let errorMessage =
    //         'Sorry, this number isn’t registered with Etisalat. Please try again with another number.';
    //       if (this.isArabic) {
    //         errorTitle = 'الرقم غير صحيح';
    //         errorMessage =
    //           'عذرًا، هذا الرقم غير مُسجل لدى اتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
    //       }
    //       this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
    //      // this.GAS.eligibilityCheck('Continue', this.mobileNumber, this.data.productType, this.data.displayName, 'error - Not eligible');

    //     }
    //   },
    //   (e: any) => {
    //     this.otpIcon="error";
    //     this.mobileErrorMSG = this.isArabic ? 'هذا الرقم ليس مسجّلاً لدى اتصالات' : e?.error?.errorDescription;
    //  //   this.GAS.eligibilityCheck('Continue', this.mobileNumber, 'error - Not eligible', this.data.productType, this.data.displayName);

    //   }
    // );
  }

  

  getControlerValue(key: string) {
   return this.ContactForm.controls[key].value
  }

  extratPrimaryAndSecNums(acounts: any ){
    acounts.forEach(element => {
      if(element.primary == true){ this.primaryNumber = element.accountNo}
      else { this.secoundyNumbers.push(element.accountNo)}
    });

  }

  
  onChangeConsent(e) { // here e is a native event
   this.showConsentPopup = !this.showConsentPopup
  }
  onChangeAlternateContact(e) { // here e is a native event
    this.showAlternateContact = !this.showAlternateContact;
  }
  onChangeTooltip(e) { // here e is a native event
    this.showConsentTooltip = !this.showConsentTooltip
   }

  validateAlternativeAccount(alternativeMobileNumber: any) {
    this.otpIcon="spinner";
    this.PS.validateAlternateContact(alternativeMobileNumber).subscribe(
      (resp) => {
        if(resp.ERROR_CODE && resp.ERROR_CODE == 'VALIDATE_ALTERNATE_CONTAT.SAME_AS_PRIMARYACCOUNT') {
          this.translate.get('ALTERNATIVE_PRIMARY_ERROR').subscribe((message) => {
            this.showOTPError = true;
            this.mobileErrorMSG = message;
          });
          return;
        }

        if (resp.success == true) {
          if (resp.otpRequired == true) {
            this.otpIcon = "verify";
            this.otpVerified = false;
            return;
          }
          this.otpIcon = "verified";
          this.otpVerified = true;
        }
        
      },
      (e) => {
        // this.UTS.error(e.error.message);
        this.otpIcon="error";
        this.mobileErrorMSG = e.error.message;
      }
    );
  }
  isMobileAndDeviceSku() {
    if (this.cart && this.cart?.items && this.cart?.items?.length > 0) {
      this.cart?.items?.forEach(element => {
        if ((element && element?.commerceItemType && element?.commerceItemType == 'mobileDevicesSku') || (element && element?.commerceItemType && element?.commerceItemType == 'mobilePlanSku')){
          this.mobileAndDeviceSku = true;
        }
        if (element && element?.commerceItemType && element?.commerceItemType == 'mobilePlanSku'){
          this.isMobilePlanSku = true;
        }
        if(element && element?.commerceItemType && element?.commerceItemType == 'mobileDevicesSku'){
          this.isDeviceSku = true;
        }
      });
    }
  }
  getCart() {
    this.CRTS.getShoppingCart().subscribe(
      (r: any) => {
        if (r && r.items) {
          this.cart = r;
          this.isMobileAndDeviceSku();
        }
      },
      (e) => {
        if (e && e.error) {
          this.UTS.error(e.error.message);
        }
      }
    );
  }

  optimizeCheckoutTracking(event, info) {
    if (this.cart?.items?.length > 0) {
      this.GAS.checkoutOptimizationTracking(event, this.cart?.items, this.cart, '', info, 'checkout');
    }
  }
}
